import { render, staticRenderFns } from "./campaignInputBox.vue?vue&type=template&id=9206744a&scoped=true&"
import script from "./campaignInputBox.vue?vue&type=script&lang=js&"
export * from "./campaignInputBox.vue?vue&type=script&lang=js&"
import style0 from "./campaignInputBox.vue?vue&type=style&index=0&id=9206744a&lang=scss&scoped=true&"
import style1 from "./campaignInputBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9206744a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VIcon,VLayout})
